import React from 'react'
import scrollTo from 'gatsby-plugin-smoothscroll'

class Supercharge extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Supercharge">
        <div className="internal">
          <h2>{this.props.title}</h2>
          <a onClick={() => scrollTo('#BuyNow')} className="Btn orange-white">{this.props.callToAction}</a>
        </div>
      </div>
    );
  }
}

export default Supercharge;



// WEBPACK FOOTER //
// ./src/home/supercharge-cta.js